import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { backIcon, crossIcon, dot } from "../../../Shared/SVGs/Shared";
import { updateCampaignFields, updateCampaignState } from "../CampaignActions";
import ReloadConfirmationModal from "./ReloadConfirmationModal";
import { useState } from "react";
import DraftModal from "./DraftModal";
import gql from "graphql-tag";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import Cookies from "js-cookie";
import { removeQueryParams } from "../../../utilities";
import { updateModalState } from "../../Dashborad/Actions";
import { convertToRaw } from "draft-js";
import {
  updateParams,
  updateVideoPageState,
  updateCampaignState as videoUpdateCampaignState,
} from "../../Video/VideoActions";

const CREATE_CAMPAIGN_MUTATION = gql`
  mutation MyMutation($campaign: clipupInput!) {
    createCampaign(campaign: $campaign) {
      _id
      logo_url
      name
      hash_tag
      banner_url
      manufacturer {
        _id
        name
      }
      products {
        _id
        name
      }
    }
  }
`;

const GET_PRESIGNED_URL = gql`
  query GetPresignedURL($fileName: String!) {
    getPresignedURL(fileName: $fileName)
  }
`;

const StepsButton = ({ qrcode, setQrcode }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [draftModal, setDraftModal] = useState(false);
  const activeStep = useSelector((state) => state.campaign_states.activeStep);

  const form = useSelector((state) => state.campaign_states.form);
  // console.log(form);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateHome = () => {
    setShowModal(false);
    navigate("/");
    dispatch(updateCampaignState({ activeStep: 1 }));
    dispatch(
      updateCampaignFields({
        campaign_headline: "",
        campaign_hashtag: "",
        campaign_brand_name: "",
        campaign_product: "",
        campaign_banner_image: "",
        campaign_banner_image_file: null,
        productimageURL: "",
        campaign_brand_image_preview: "",
        campaign_banner_image_preview: "",
        campaign_brand_image: "",
        campaign_description: "",
        campaign_reward: "",
        end_date: null,
        time: "",
        start_date: moment(),
        start_time: "",
        end_time: "",
        campaign_timezone: "GMT-07:00 (Pacific Daylight Time)",
        currentTime: "",
        campaign_reward_type: "",
        ongoing: false,
        products: [],
        campaign_video_limit: 200,
        campaign_video_length: "",
        campaign_allow_rating: false,
        banner_with_qr: "",
        terms_and_conditions: "",
        image_dimensions: "Fit",
        description_editor_state: null,
        terms_and_conditions_editor_state: null,
      })
    );
  };
  const cancelReload = () => {
    setShowModal(false);
  };
  const showCampaignStep = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignStep
  );
  const campaignId = useSelector(
    (state) => state.videoPageStates.campaignsState.campaignId
  );
  const openModal = () => {
    if (activeStep === 5 || (activeStep === 4 && showCampaignStep)) {
      if (showCampaignStep) {
        dispatch(
          updateCampaignFields({
            banner_share_url: "",
            banner_with_qr: "",
          })
        );
        navigate(`/videos/campaigns/${campaignId}`);
        dispatch(
          updateCampaignFields({
            campaign_headline: "",
            campaign_hashtag: "",
            campaign_brand_name: "",
            campaign_product: "",
            campaign_banner_image: "",
            campaign_banner_image_file: null,
            productimageURL: "",
            campaign_brand_image_preview: "",
            campaign_banner_image_preview: "",
            campaign_brand_image: "",
            campaign_description: "",
            brand_instruction: "",
            campaign_reward: "",
            end_date: null,
            time: "",
            start_date: moment(),
            start_time: "",
            end_time: "",
            campaign_timezone: "GMT-07:00 (Pacific Daylight Time)",
            currentTime: "",
            campaign_reward_type: "",
            ongoing: false,
            products: [],
            campaign_video_limit: 200,
            campaign_video_length: "",
            campaign_allow_rating: false,
            banner_with_qr: "",
            banner_share_url: "",
            terms_and_conditions: "",
            image_dimensions: "Fit",
            description_editor_state: null,
            description_editor_state: null,
            brand_instruction_editor_state: null,
            hashtag_editor_state: null,
            campaign_hashtag_editor: "",
            preview_color_change: "#526261",
            color_change_hashtag: "#FC80BB",
            headline_editor_state: null,
            campaign_headline_editor: "",
            terms_and_conditions_editor_state: null,
            campaign_video_length_type: "",
            campaign_button_color: "#96C392",
            campaign_button_text_color: "white",
            campaign_upload_platform: [],
          })
        );
      } else {
        setDraftModal(true);
      }
    } else {
      setShowModal(true);
    }
  };

  const [createCampaign] = useMutation(CREATE_CAMPAIGN_MUTATION);
  const { refetch } = useQuery(GET_PRESIGNED_URL, {
    skip: true,
  });

  const handleSubmit = async () => {
    setLoading(true);
    const {
      campaign_headline,
      campaign_hashtag,
      campaign_brand_name,
      campaign_brand_image,
      campaign_reward,
      start_date,
      end_date,
      start_time,
      end_time,
      campaign_timezone,
      products,
      ongoing,
      campaign_video_limit,
      campaign_allow_rating,
      campaign_video_length,
      terms_and_conditions,
      campaign_description,
      campaign_reward_type,
      campaign_banner_image_file,
      campaign_banner_image_preview,
      image_dimensions,
      description_editor_state,
      terms_and_conditions_editor_state,
      brand_instruction,
      brand_instruction_editor_state,
      campaign_video_length_type,
      campaign_headline_editor,
      campaign_hashtag_editor,
      headline_editor_state,
      hashtag_editor_state,
      preview_color_change,
      campaign_button_color,
      campaign_button_text_color,
      campaign_upload_platform,
    } = form;
    try {
      let serializedContentDesc = null;
      let serializedContentBrand = null;
      let serializedContentHashtag = null;
      let serializedContentHeadline = null;
      let serializedContentTerm = null;

      if (description_editor_state) {
        const rawContentStateDesc = convertToRaw(
          description_editor_state.getCurrentContent()
        );
        serializedContentDesc = JSON.stringify(rawContentStateDesc);
      }

      if (headline_editor_state) {
        const rawContentStateHead = convertToRaw(
          headline_editor_state.getCurrentContent()
        );
        serializedContentHeadline = JSON.stringify(rawContentStateHead);
      }

      if (hashtag_editor_state) {
        const rawContentStateHash = convertToRaw(
          hashtag_editor_state.getCurrentContent()
        );
        serializedContentHashtag = JSON.stringify(rawContentStateHash);
      }

      if (brand_instruction_editor_state) {
        const rawContentStateBrand = convertToRaw(
          brand_instruction_editor_state.getCurrentContent()
        );
        serializedContentBrand = JSON.stringify(rawContentStateBrand);
      }

      if (terms_and_conditions_editor_state) {
        const rawContentStateTerm = convertToRaw(
          terms_and_conditions_editor_state.getCurrentContent()
        );
        serializedContentTerm = JSON.stringify(rawContentStateTerm);
      }
      const newProducts = products
        ?.filter((product) => product?.__isNew__)
        .map((product) => product?.label);

      const formattedStartTime = start_time && start_time?.format("HH:mm");
      const formattedEndTime = end_time && end_time?.format("HH:mm");

      const formattedStartDate = moment(start_date)?.set({
        hour: start_time && start_time?.hour(),
        minute: start_time && start_time?.minute(),
      });

      const formattedEndDate = ongoing
        ? false
        : moment(end_date)?.set({
            hour: end_time && end_time?.hour(),
            minute: end_time && end_time?.minute(),
          });

      let campaignBannerImage = campaign_banner_image_preview || "";

      if (campaign_banner_image_file) {
        const { data: urlData } = await refetch({
          fileName: campaign_banner_image_file.name,
        });

        const uploadImageResponse = await fetch(urlData.getPresignedURL, {
          method: "PUT",
          headers: {
            "Content-Type": campaign_banner_image_file.type,
          },
          body: campaign_banner_image_file,
        });

        if (!uploadImageResponse.ok) {
          setLoading(false);
          throw new Error("Failed to upload image");
        }

        campaignBannerImage = removeQueryParams(urlData.getPresignedURL);
      }

      const campaignData = {
        description_editor_state: serializedContentDesc,
        brand_instruction_editor_state: serializedContentBrand,
        headline_editor_state: serializedContentHeadline,
        hashtag_editor_state: serializedContentHashtag,
        terms_and_conditions_editor_state: serializedContentTerm,
        status: "draft",
        campaign_banner_image: campaignBannerImage,
        campaign_hashtag,
        campaign_brand_image,
        campaign_brand_name,
        campaign_description,
        campaign_upload_platform,
        brand_instruction,
        campaign_headline_editor,
        campaign_hashtag_editor,
        campaign_headline,
        preview_color_change,
        campaign_button_color,
        campaign_button_text_color,
        campaign_product: "campaign_product",
        campaign_reward,
        campaign_reward_type,
        campaign_timezone,
        manufacturer: {
          _id: Cookies.get("bId"),
          name: campaign_brand_name,
        },
        products: products
          ?.filter((product) => !product?.__isNew__)
          .map((product) => ({
            _id: product?.value,
            name: product?.label,
          })),
        ...(newProducts?.length > 0 && { newProducts }),
        start_date: formattedStartDate,
        start_time: formattedStartTime,
        ...(ongoing ? {} : { end_date: formattedEndDate }),
        ongoing,
        end_time: formattedEndTime,
        terms_and_conditions,
        ...(campaign_video_limit > 0 && { campaign_video_limit }),
        campaign_allow_rating,
        campaign_video_time_limit: `${campaign_video_length}`,
        campaign_video_length_type,
        descriptionRenderAs: "html",
        termAndConditionRenderAs: "html",
        bannerRenderAs: image_dimensions,
      };

      const { data: response } = await createCampaign({
        variables: { campaign: campaignData },
      });

      if (response) {
        setLoading(false);
        setShowModal(false);
        setDraftModal(true);
        dispatch(
          updateCampaignState({ campaign_response: response.createCampaign })
        );
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <ReloadConfirmationModal
        isOpen={showModal}
        onConfirm={navigateHome}
        onCancel={cancelReload}
        handleSubmit={handleSubmit}
        loading={loading}
      />
      <DraftModal open={draftModal} toggle={() => setDraftModal(false)} />
      <div
        className="d-flex gap-1 align-items-center"
        style={{ position: "absolute", left: "15px", top: "40px" }}
        role="button"
        onClick={() => {
          if (activeStep === 1) {
            navigate("/");
            dispatch(updateModalState(true));
          }
          if (activeStep === 5 && qrcode) {
            setQrcode(false);
          } else {
            dispatch(updateCampaignState({ activeStep: activeStep - 1 }));
          }
        }}
      >
        {activeStep === 5 && (qrcode || showCampaignStep) ? (
          <>
            {" "}
            <p>{backIcon}</p> <p className="back">Back</p>
          </>
        ) : (
          <>
            {" "}
            {activeStep !== 5 && activeStep !== 4 && (
              <>
                <p>{backIcon}</p> <p className="back">Back</p>
              </>
            )}
          </>
        )}
      </div>

      <div
        role="button"
        style={{ position: "absolute", right: "15px", top: "50px" }}
        id="crossButton"
        onClick={openModal}
      >
        {crossIcon}
      </div>
    </div>
  );
};

export default StepsButton;
